// Current season first, "beide" second, other season last - each FAQ item
// already carries its own raw data-saison, so re-sorting client-side avoids
// a full server round-trip. A stable sort keeps each group's existing
// (menu_order-based) relative order intact.
function reorderFaqs(season) {
    const otherSeason = season === "sommer" ? "winter" : "sommer";
    const priority = { [season]: 0, beide: 1, [otherSeason]: 2 };

    document.querySelectorAll(".questionsOuter").forEach(function (container) {
        const items = Array.from(container.querySelectorAll(".questionItem"));
        items
            .map(function (item, index) {
                return { item: item, index: index };
            })
            .sort(function (a, b) {
                const pa = priority[a.item.dataset.saison] ?? 3;
                const pb = priority[b.item.dataset.saison] ?? 3;
                return pa !== pb ? pa - pb : a.index - b.index;
            })
            .forEach(function (entry) {
                container.appendChild(entry.item);
            });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    if (typeof lhmSeasonSwitcher === "undefined") {
        return;
    }

    const seasonSwitchOverlay = document.getElementById("seasonSwitchOverlay");

    document.querySelectorAll(".seasonSwitch").forEach(function (button) {
        button.addEventListener("click", function () {
            const nextSeason = button.dataset.currentSeason === "sommer" ? "winter" : "sommer";

            document.body.classList.remove("season-sommer", "season-winter");
            document.body.classList.add("season-" + nextSeason);

            document.querySelectorAll(".headerBannerMedia[class*='headerBannerMedia-']").forEach(function (media) {
                const isActive = media.classList.contains("headerBannerMedia-" + nextSeason);
                media.classList.toggle("headerBannerMedia-inactive", !isActive);
            });

            if (typeof window.lhm_deferHeaderVideos === "function") {
                window.lhm_deferHeaderVideos(".headerBannerMedia-" + nextSeason + " .headerVideoPlayer");
            }

            if (typeof window.lhmCloseAllSubmenus === "function") {
                window.lhmCloseAllSubmenus();
            }

            const siteNav = document.getElementById("site-navigation");
            if (siteNav && siteNav.classList.contains("toggled") && typeof window.lhmToggleNavigation === "function") {
                window.lhmToggleNavigation();
            }

            if (seasonSwitchOverlay) {
                seasonSwitchOverlay.classList.add("seasonSwitchOverlay-active");
            }

            button.disabled = true;

            const formData = new FormData();
            formData.append("action", "lhm_child_toggle_season");
            formData.append("nonce", lhmSeasonSwitcher.nonce);
            formData.append("season", nextSeason);
            formData.append("post_id", lhmSeasonSwitcher.postId);

            fetch(lhmSeasonSwitcher.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    if (!result.success) {
                        return;
                    }

                    const masthead = document.getElementById("masthead");
                    if (masthead && result.data.menufarbe) {
                        masthead.classList.remove("menufarbe-hell", "menufarbe-dunkel");
                        masthead.classList.add("menufarbe-" + result.data.menufarbe);
                    }

                    reorderFaqs(result.data.season);

                    const nextSeasonLabel = result.data.season === "winter" ? lhmSeasonSwitcher.labelSommer : lhmSeasonSwitcher.labelWinter;
                    const switchLabel = lhmSeasonSwitcher.switchLabelPattern.replace("%s", nextSeasonLabel);

                    document.querySelectorAll(".seasonSwitch").forEach(function (switcher) {
                        switcher.dataset.currentSeason = result.data.season;
                        switcher.setAttribute("aria-label", switchLabel);
                        switcher.querySelectorAll(".seasonSwitchIcon").forEach(function (icon) {
                            icon.classList.toggle("isActive", icon.dataset.season === result.data.season);
                        });
                        switcher.querySelectorAll(".seasonSwitchLabel").forEach(function (label) {
                            label.classList.toggle("isActive", label.dataset.season === result.data.season);
                        });
                    });
                })
                .finally(function () {
                    button.disabled = false;

                    if (seasonSwitchOverlay) {
                        seasonSwitchOverlay.classList.remove("seasonSwitchOverlay-active");
                    }
                });
        });
    });
});
